
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Row, Tag } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'TransactionDetails',
  components: { Row, Tag }
})
export default class TransactionDetails extends Vue {
  @Prop({ type: String, required: true })
  private portfolioName!: string;

  @Prop({ type: String, required: true })
  private depositAmount!: string;

  private get disclaimerMessage() {
    return `O valor já pode ser visualizado dentro da sua carteira. A partir de agora, cada produto tem seu tempo específico para efetivação do investimento`;
  }
}
